import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleCreateMilestone(
  list: Identifiable<List>,
  data: Boundaries["createMilestone"]["success"],
): Identifiable<List> {
  const { milestone, list: target } = data;
  const isTargetList = target.uuid === list.uuid;

  return isTargetList
    ? { ...list, milestones: [...list.milestones, milestone] }
    : {
        ...list,
        subLists: list.subLists.map((subList) =>
          handleCreateMilestone(subList, data),
        ),
      };
}

export { handleCreateMilestone };
